export default "__VITE_ASSET__BRc7mxi5__"